import {DatasetsApi} from "api/DatasetsApi";
import CopyTextWithButton from "components/basic/copy-text-with-button/CopyTextWithButton";
import React, {useEffect, useState} from "react";
import {useGetRecentData} from "api/api-hooks/datasets-hooks";
import {AutoComplete, AutoCompleteChangeParams, AutoCompleteCompleteMethodParams} from "primereact/autocomplete";
import {timeAgo} from "utils/time-utils";

interface IDatasetDropdownProps {
    // Dataset identifier
    value?: string | null;
    onChange: (e: string | null) => void;
    style?: React.CSSProperties;
    disabled?: boolean;
}

interface DropdownItem {
    value: string | number,
    label: string,
}

export function DatasetDropdown(props: IDatasetDropdownProps) {
    const [selectedDataset, setSelectedDataset] = useState<DropdownItem | null>(null);
    const [filteredDatasets, setFilteredDatasets] = useState<DropdownItem[]>([]);

    const [error, setError] = useState(false);
    const recentDataQuery = useGetRecentData([props.value!], {});

    useEffect(() => {
        if (recentDataQuery.data !== undefined && recentDataQuery.data.length > 0) {
            const dataset = recentDataQuery.data[0]!!
            let label = `${dataset.title} `;

            if(dataset.data.length > 0) {
                const {key: time, value} = dataset.data[0];
                setSelectedDataset({value: dataset.identifier, label: `${label} | ${value.toFixed(2)} ${dataset.unit} | ${timeAgo(time)}`});
            } else {
                setSelectedDataset({value: dataset.identifier, label: `${label} | ${dataset.unit}`});
            }
        }
    }, [recentDataQuery.data]);

    const searchDatasets = (e: AutoCompleteCompleteMethodParams) => {
        DatasetsApi.queryDatasets(e.query, 100).then((r) => {
            if (!r.error && r.data) {
                const selections = r.data.map((it) => ({value: it.identifier, label: it.toString()} as DropdownItem))
                setFilteredDatasets(selections)
            } else {
                setError(true)
            }
        });
    }

    const onChange = (e: AutoCompleteChangeParams) => {
        setSelectedDataset(e.value);

        if (typeof e.value === "string") return; // Ignore string auto complete dumb input

        props.onChange(e.value?.value || null);
    }

    return (
        <div style={{display: 'flex', alignItems: 'center', width: "100%"}}>
            <AutoComplete placeholder="Select Dataset"
                          value={selectedDataset}
                          suggestions={filteredDatasets}
                          onChange={onChange}
                          completeMethod={searchDatasets}
                          minLength={3}
                          field="label"
                          onClear={() => {
                              setSelectedDataset(null);
                              props.onChange(null);
                          }}
                          dropdownMode="blank"
                          style={{width: "100%", ...props.style}}
                          dropdown
                          disabled={props.disabled}
            />
            {selectedDataset && <CopyTextWithButton text="" copyableText={props.value ?? ""} />}
        </div>
    );
}